<template>
    <card>
        <div class="card-header">
            <h5 class="title">Edit Project</h5>
        </div>
        <div class="card-body">
            <form>
                <div class="row">
                    <base-input class="col-md-4 pr-md-1"
                                label="Project full name"
                                v-model="settings.full_name"
                                placeholder="Full name">
                    </base-input>
                    <base-input class="col-md-4 pr-md-1"
                                label="Project short name"
                                v-model="settings.short_name"
                                placeholder="Short name">
                    </base-input>
                    <base-input class="col-md-4 pr-md-1"
                                label="Project site name"
                                v-model="settings.site_name"
                                placeholder="Site name">
                    </base-input>
                </div>
                <div class="row">
                    <base-input class="col-md-3 col-6">
                        <base-checkbox class="mb-3" v-model="settings.is_active">
                            Active
                        </base-checkbox>
                    </base-input>
                    <base-input class="col-md-3 col-6">
                        <base-checkbox class="mb-3" v-model="settings.is_commercial">
                            Commercial
                        </base-checkbox>
                    </base-input>
                    <base-input class="col-md-3 col-6">
                        <base-checkbox class="mb-3" v-model="settings.is_show">
                            Shown
                        </base-checkbox>
                    </base-input>
                    <base-input class="col-md-3 col-6">
                        <base-checkbox class="mb-3" v-model="settings.is_delete">
                            Deleted
                        </base-checkbox>
                    </base-input>
                </div>
                <div class="row">
                    <base-input class="col-md-12"
                                label="Address of the Project"
                                v-model="address[0]"
                                placeholder="Street">
                    </base-input>
                </div>
                <div class="row">
                    <base-input class="col-md-4 pr-md-1"
                                label="City"
                                v-model="address[1]"
                                placeholder="City">
                    </base-input>
                    <base-input class="col-md-4 pr-md-1"
                                label="Country"
                                v-model="address[2]"
                                placeholder="Country">
                    </base-input>
                    <base-input class="col-md-4 pr-md-1"
                                label="Postal Code"
                                v-model="address[3]"
                                placeholder="ZIP Code">
                    </base-input>
                </div>
                <div class="row">
                    <base-input class="col-md-8">
                        <label>Description of the project</label>
                        <textarea rows="4" cols="80"
                                  class="form-control"
                                  placeholder=""
                                  v-model="settings.description">
              </textarea>
                    </base-input>
                </div>
            </form>
        </div>
        <div class="card-footer">
            <div class="row">
                <div class="col-lg-12 ml-auto mr-auto">
                    <div class="row">
                        <div class="col-md-2 col-lg-2">
                            <button type="button" class="btn btn-fill btn-warning" v-on:click="save" style="min-width: 160px;">Save</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </card>
</template>

<script>
export default {
    name: "project-settings-form",
    props: ['settings'],
    data(){
        return{
            address: [],
        }
    },
    methods: {
        save(){
            this.$emit('save', this.address);
        },
    },
    created() {
        if (this.settings.address !== '' && this.settings.address !== null){
            this.address = this.settings.address.split('||');
        }
        else{
            this.address = ['','','',''];
        }
    }
}
</script>

<style scoped>

</style>
